module.exports = __webpack_public_path__ + "static/media/insect(13).144a6e2f.PNG";